/** @module csi/widget/PillAnchor */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dojo/text!./PillAnchor.html"
], function(declare,_TemplatedMixin,_WidgetBase,template) {

	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		/** @property {string} baseClass - CSS class used to style pair */
		baseClass: "csi-name-value-pair",

		/** @property {string} href */
		href: "",

		/** @property {string} value */
		value: "",

		_setHrefAttr: {node: "valueNode", type: "attribute"},
		_setValueAttr: {node: "valueNode", type: "innerText"}
	});
});